<ngx-spinner></ngx-spinner>

<hr class="style1">

<div class="container" *ngIf="showActivePromo">

  <!-- ------------------DETALLE PROMOCION >= Long-Devices ----------------------->
  <div class="row d-none d-lg-block p-20">
    <div class="col-lg-12 pb-20">
      <button type="button" class="btn btn-primary" [routerLink]="['/cardPromos',selectedIdCard,lastPage]">
        &nbsp;<span class="glyphicon glyphicon-triangle-left" style="color: yellow;"></span> Regresar&nbsp;&nbsp;&nbsp;
      </button>
    </div>
  </div>

  <div class="row d-none d-lg-block p-10 w-100">
    <div class="col-lg-5" style="max-width: 460px;">
      <img src="{{selectedPromo.urlImagenDetalle}}" width="400" height="400" />
    </div>
    <div class="col-lg-7 p-0">
      <div class="row p-10 d-flex align-items-center" style="height: 170px;">
        <div class="col-lg-12 d-flex align-items-center p-0">

          <div class="row w-100 p-0">
            <div class="col-lg-6 justify-content-left w-100 p-0">
              <img src="{{selectedPromo.comercio.urlLogoImagen}}" width="120" height="120" />
            </div>
            <div class="col-lg-6 justify-content-right text-right w-100 p-0">
              <p class="coupon-type-style">{{selectedPromo.tipoCupon.descripcion}}</p>
            </div>
          </div>

        </div>
      </div>
      <div class="row d-flex align-items-baseline">
        <div class="col-lg-12 d-flex align-items-baseline p-0">
          <p class="merchant-name-style">{{selectedPromo.comercio.nombre}}</p>
        </div>
      </div>
      <div class="row d-flex align-items-baseline" *ngIf="selectedPromo.comercio.descripcion !== null">
        <div class="col-lg-12 d-flex align-items-baseline p-0">
          <p class="merchant-desc-style">{{selectedPromo.comercio.descripcion}}</p>
        </div>
      </div>
      <div class="row p-0">
        <div class="col-lg-12 p-0">
          <p class="promo-name-style">{{selectedPromo.nombre}}</p>
        </div>
      </div>
      <div class="row">
        <div class="col-lg-12 p-0">
          <div class="promo-data-style" [innerHTML]="formatBold(selectedPromo.descripcion)"></div>
        </div>
      </div>
      <div class="row">
        <div class="col-lg-12 p-0">
          <p *ngIf="selectedPromo.proximamente === 0" class="promo-duration-style">Vigencia: al {{selectedPromo.vigenciaFin}}</p>
          <p *ngIf="selectedPromo.proximamente === 1" class="promo-duration-style">Vigencia: Del {{selectedPromo.vigenciaInicio}}  al {{selectedPromo.vigenciaFin}}</p>
        </div>
      </div>
      <div class="row">
        <div class="col-lg-12 p-0">
          <p class="promo-target-style">{{selectedPromo.presencia}}</p>
        </div>
      </div>
      <div class="row justify-content-left">
        <div class="col-lg-12 justify-content-left p-0">
          <a href="{{selectedPromo.comercio.sitioWeb}}" target="_blank" class="btn-bc-tertiary btn btn-xs btn-default">
            <div>
              <span class="promo-site-style"><i class="icon icon-chevron-right-small" aria-hidden="true"></i>Visita el
                sitio</span><span> </span><span></span>
            </div>
          </a>
        </div>
      </div>
    </div>
  </div>

  <div class="row d-none d-lg-block p-20">
    <div class="col-lg-5" style="max-width: 440px;">

    </div>
    <div class="col-lg-7 pt-20 p-0">
      <div class="row p-1">
        <div class="col-lg-4">
          <div class="row" style="height: 25px;">
            <div class="col-lg-12">
              <p class="promo-share-style">Comparte esta promoción</p>
            </div>
          </div>
          <div class="row p-0">
            <div class="col-lg-12">
              <div class="row">
                &nbsp;&nbsp;&nbsp;&nbsp;
                <a class="show-hand" (click)="sharePromoFacebook(selectedPromo.idPromocion)"><img
                  src="assets/img/FB_share.png" width="33" height="33"></a>&nbsp;
                <a class="show-hand"
                   (click)="sharePromoTwitter(selectedPromo.idPromocion, selectedPromo.comercio.nombre, selectedPromo.nombre)"><img
                  src="assets/img/TW_share.png" width="33" height="33"></a>
                <a class="show-hand pl-1" (click)="sharePromoWhatsapp(selectedPromo.idPromocion)">
                  <img src="assets/img/whatsapp_icon_x2.jpg" width="34" height="34">
                </a>&nbsp;

              </div>
            </div>
          </div>
        </div>
        <div class="col-lg-8">
          <img src="{{cardRelation.tarjeta.urlImagen}}" alt="{{cardRelation.tarjeta.nombre}}" [ngClass]="selectedPromo.tarjetas.length==5 ? 'img-cards-all-style': 'img-cards-style'"
             *ngFor="let cardRelation of selectedPromo.tarjetas; let i = index">
        </div>
      </div>
    </div>
  </div>


  <!-- -----End-------DETALLE PROMOCION > Long-Devices ----------------------->

  <!-- ------------------DETALLE PROMOCION = Medium-Devices ----------------------->
  <div class="row d-none d-md-block d-lg-none p-20">
    <div class="col-12 pb-10">
      <button type="button" class="btn btn-primary" [routerLink]="['/cardPromos',selectedIdCard,lastPage]">
        &nbsp;<span class="glyphicon glyphicon-triangle-left" style="color: yellow;"></span> Regresar&nbsp;&nbsp;&nbsp;
      </button>
    </div>
  </div>

  <div class="row d-none d-md-block d-lg-none p-0 w-100">
    <div class="col-12">
      <div class="row">
        <div class="col-8">
          <img src="{{selectedPromo.urlImagenDetalle}}" width="400" height="400" />
        </div>
        <div class="col-4 justify-content-center">
          <div class="row p-10 d-flex align-items-center justify-content-center" style="height: 170px;">
            <div class="col-12 d-flex align-items-center justify-content-center p-0">
              <img src="{{selectedPromo.comercio.urlLogoImagen}}" width="120" height="120" />
            </div>
          </div>
          <div class="row">
            <div class="col-12 justify-content-center text-center w-100 p-0">
              <p class="coupon-type-md-style">{{selectedPromo.tipoCupon.descripcion}}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>


  <div class="row d-none d-md-block d-lg-none p-0">
    <div class="col-12 d-flex align-items-baseline p-0">
      <p class="merchant-md-name-style">{{selectedPromo.comercio.nombre}}</p>
    </div>
    <div class="col-12 p-0" *ngIf="selectedPromo.comercio.descripcion !== null">
      <div class="col-12 d-flex align-items-baseline p-0">
        <p class="merchant-desc-style">{{selectedPromo.comercio.descripcion}}</p>
      </div>
    </div>
    <div class="col-12 p-0">
      <p class="promo-md-name-style">{{selectedPromo.nombre}}</p>
    </div>
  </div>

  <div class="row d-none d-md-block d-lg-none">
    <div class="col-12 p-0">
      <div class="promo-md-data-style" [innerHTML]="formatBold(selectedPromo.descripcion)"></div>
    </div>
  </div>
  <div class="row d-none d-md-block d-lg-none">
    <div class="col-lg-12 p-0">
      <p *ngIf="selectedPromo.proximamente === 0" class="promo-md-duration-style">Vigencia: al {{selectedPromo.vigenciaFin}}</p>
      <p *ngIf="selectedPromo.proximamente === 1" class="promo-md-duration-style">Vigencia: Del {{selectedPromo.vigenciaInicio}}  al {{selectedPromo.vigenciaFin}}</p>
    </div>
    <div class="col-lg-12 p-0">
      <p class="promo-md-target-style">{{selectedPromo.presencia}}</p>
    </div>
  </div>
  <div class="row d-none d-md-block d-lg-none">
    <div class="col-12 p-0">
      <a href="{{selectedPromo.comercio.sitioWeb}}" target="_blank" class="btn-bc-tertiary btn btn-xs btn-default">
        <div>
          <span class="promo-md-site-style"><i class="icon icon-chevron-right-small" aria-hidden="true"></i>Visita el
            sitio</span><span> </span><span></span>
        </div>
      </a>
    </div>
  </div>


  <div class="row d-none d-md-block d-lg-none p-20">

    <div class="col-12 pt-20 p-0">
      <div class="row p-1">
        <div class="col-4">
          <div class="row" style="height: 25px;">
            <div class="col-12">
              <p class="promo-share-style">Comparte esta promoción:</p>
            </div>
          </div>
          <div class="row p-0">
            <div class="col-2">
              <a  class="" (click)="sharePromoFacebook(selectedPromo.idPromocion)"><img
                  src="assets/img/FB_share.png" width="33" height="33"></a>&nbsp;
            </div>
            <div class="col-2">
              <a  class=""
                (click)="sharePromoTwitter(selectedPromo.idPromocion, selectedPromo.comercio.nombre, selectedPromo.nombre)"><img
                  src="assets/img/TW_share.png" width="33" height="33"></a>
            </div>
            <div class="col-2">
              <a class="show-hand" (click)="sharePromoWhatsapp(selectedPromo.idPromocion)">
                <img src="assets/img/whatsapp_icon_x2.jpg" width="34" height="34">
              </a>&nbsp;
            </div>
          </div>
        </div>
        <div class="col-8">
          <img src="{{cardRelation.tarjeta.urlImagen}}" alt="{{cardRelation.tarjeta.nombre}}" [ngClass]="selectedPromo.tarjetas.length==5 ? 'img-cards-all-style': 'img-cards-style'"
            width="100" height="65" *ngFor="let cardRelation of selectedPromo.tarjetas; let i = index">
        </div>
      </div>
    </div>
  </div>
  <!-- -----End-------DETALLE PROMOCION = Medium-Devices ----------------------->

<!-- ------------------DETALLE PROMOCION <= Small-Devices ----------------------->
<div class="row d-block d-md-none p-0">
  <div class="col-12 pb-10">
    <div class="row">
      <div class="col-4">
       <button type="button" class="btn btn-primary" [routerLink]="['/cardPromos',selectedIdCard,lastPage]" >
        &nbsp;<span class="glyphicon glyphicon-triangle-left" style="color: yellow;"></span> Regresar&nbsp;&nbsp;&nbsp;
       </button>
      </div>
      <div class="col-8 justify-content-right text-right w-100 p-0">
        <p class="coupon-type-sm-style">{{selectedPromo.tipoCupon.descripcion}}</p>
      </div>
    </div>
  </div>
</div>


<nav class="d-block d-md-none p-0 w-100" [ngStyle]="{'background-image': 'url(' + selectedPromo.urlImagenDetalle +')', 'background-repeat': 'no-repeat', 'background-size': '100% 330px'}">
<!-- <div class="row d-block d-md-none p-0" [ngStyle]="{background: 'url(' + selectedPromo.urlImagenDetalle +')', 'background-repeat': 'no-repeat', 'background-size': '100% 100%'}"> -->
  <div class="row p-0 w-100" style="height: 400px; ">
    <div class="col-12 p-0">
      <div class="container">
        <div class="row p-0 w-100">
          <div class="col-1"></div>
          <div class="col-3">

            <div class="row justify-content-left" style="height: 400px;">
              <div class="col-12" style="height: 400px;">
                <div class="row p-20 text-left  align-items-end"
                  style="height: 62%; ">
                  <div class="col-12 promo-name justify-content-left text-left" style="padding-left: 0px;">
                    <img  class="promo-img-box" src="{{selectedPromo.comercio.urlLogoImagen}}" width="100" height="100" />
                  </div>
                </div>
              </div>
            </div>

          </div>
          <div class="col-8"></div>
        </div>
      </div>
    </div>
  </div>
<!-- </div> -->
</nav>

  <!-- <div class="row d-block d-md-none p-0 w-100" style="margin: 0;">
    <div class="col-12">
      <div class="row">
        <div class="col-8">
          <img src="{{selectedPromo.urlImagenDetalle}}" width="400" height="400" />
        </div>
        <div class="col-4 justify-content-center">
          <div class="row p-10 d-flex align-items-center justify-content-center" style="height: 170px;">
            <div class="col-12 d-flex align-items-center justify-content-center p-0">
              <img src="{{selectedPromo.comercio.urlLogoImagen}}" width="120" height="120" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div> -->


<div class="row d-block d-md-none d-flex align-items-baseline p-2">
  <div class="col-12 d-flex align-items-baseline p-0">
    <p class="merchant-md-name-style">{{selectedPromo.comercio.nombre}}</p>
  </div>
  <div class="col-12 p-0" *ngIf="selectedPromo.comercio.descripcion !== null">
    <div class="col-12 d-flex align-items-baseline p-0">
      <p class="merchant-desc-style">{{selectedPromo.comercio.descripcion}}</p>
    </div>
  </div>
  <div class="col-12 p-0">
    <p class="promo-md-name-style">{{selectedPromo.nombre}}</p>
  </div>
</div>

<div class="row d-block d-md-none d-lg-none p-2">
  <div class="col-12 p-0">
    <div class="promo-md-data-style" [innerHTML]="formatBold(selectedPromo.descripcion)"></div>
  </div>
</div>
<div class="row d-block d-md-none d-lg-none p-2">
  <div class="col-lg-12 p-0">
    <p *ngIf="selectedPromo.proximamente === 0" class="promo-md-duration-style">Vigencia: al {{selectedPromo.vigenciaFin}}</p>
    <p *ngIf="selectedPromo.proximamente === 1" class="promo-md-duration-style">Vigencia: Del {{selectedPromo.vigenciaInicio}}  al {{selectedPromo.vigenciaFin}}</p>
  </div>
  <div class="col-lg-12 p-0">
    <p class="promo-md-target-style">{{selectedPromo.presencia}}</p>
  </div>
</div>
<div class="row d-block d-md-none d-lg-none">
  <div class="col-12 p-0">
    <a href="{{selectedPromo.comercio.sitioWeb}}" target="_blank" class="btn-bc-tertiary btn btn-xs btn-default">
      <div>
        <span class="promo-md-site-style"><i class="icon icon-chevron-right-small" aria-hidden="true"></i>Visita el
          sitio</span><span> </span><span></span>
      </div>
    </a>
  </div>
</div>


<div class="row d-block d-md-none p-20">

  <!-- Solo visible para SMALL devices-->
  <div class="row d-none d-sm-block d-md-none p-2">
    <div class="col-12">
      <img src="{{cardRelation.tarjeta.urlImagen}}" alt="{{cardRelation.tarjeta.nombre}}" [ngClass]="selectedPromo.tarjetas.length==5 ? 'img-cards-all-style-mobile': 'img-cards-style-mobile'"
         *ngFor="let cardRelation of selectedPromo.tarjetas; let i = index">
    </div>
  </div>

   <!-- Solo visible para XSMALL devices-->
  <div class="row d-block d-sm-none p-2">
    <div class="col-12">
      <img src="{{cardRelation.tarjeta.urlImagen}}" alt="{{cardRelation.tarjeta.nombre}}" [ngClass]="selectedPromo.tarjetas.length==5 ? 'img-cards-all-style-mobile': 'img-cards-style-mobile-xsmall'"
        *ngFor="let cardRelation of selectedPromo.tarjetas; let i = index">
    </div>
  </div>

  <div class="row">
    <div class="col-12">
      <br>
    </div>
  </div>

  <div class="row p-2">
    <div class="col-12">
      <div class="row" style="height: 25px;">
        <div class="col-12">
          <p class="promo-share-style">Comparte esta promoción:</p>
        </div>
      </div>
    </div>
  </div>

  <div class="row p-2">
    <div class="col-1">
      <a  class="" (click)="sharePromoFacebook(selectedPromo.idPromocion)"><img
        src="assets/img/FB_share.png" width="33" height="33"></a>&nbsp;
    </div>
    <div class="col-1">
      <a  class="pl-1"
          (click)="sharePromoTwitter(selectedPromo.idPromocion, selectedPromo.comercio.nombre, selectedPromo.nombre)"><img
        src="assets/img/TW_share.png" width="33" height="33"></a>
    </div>
    <div class="col-1">
      <a class="pl-2" (click)="sharePromoWhatsapp(selectedPromo.idPromocion)">
        <img src="assets/img/whatsapp_icon_x2.jpg" width="34" height="34">
      </a>&nbsp;
    </div>
  </div>





</div>
<!-- -----End-------DETALLE PROMOCION <= SMALL-Devices ----------------------->


  <div class="row w-100">
    <div class="col-12">
      <br>
    </div>
  </div>

  <div class="row w-100" >
    <div class="col-lg-12">
      <div class="card card-body">
        <div class="row">
          <div class="col-lg-7 col-md-7 col-sm-9 col-xs-9 text-right" style="margin-top: 10px;">
            <p class="promo-terms-style">T&eacute;rminos y condiciones</p>
          </div>
          <div class="col-lg-5 col-md-5 col-sm-3 col-xs-3 text-left">
            <a class="btn" data-toggle="collapse" href="#collapseExample" role="button" aria-expanded="false"
              aria-controls="collapseExample">
              <img src="assets/img/Plus_Circle.png">
            </a>
          </div>
        </div>
        <hr class="style2">
        <div class="collapse" id="collapseExample">
          <div class="promo-terms-style" [innerHTML]="formatBold(selectedPromo.terminos)"></div>
        </div>
      </div>

    </div>
  </div>

  <div class="row p-20">
    <div class="col-lg-12 text-center">
      &nbsp;
    </div>
  </div>

  <div class="row p-20" *ngIf="showMap">
    <div class="col-12 text-center">
      <p class="branch-select-style">Selecciona una Sucursal</p>
    </div>
  </div>

  <!-- Seleccion de Ciudad / Sucursal > Long-Devices -->

  <div class="row d-none d-lg-block  p-10 justify-content-center" *ngIf="showMap">
    <div class="col-lg-3 text-right"></div>
    <div class="col-lg-3 text-right">
      <button type="button" class="btn selectpicker btn-primary" data-toggle="dropdown" title="Elige una ciudad"
        aria-expanded="false" style="width: 100%;" [disabled]="selectCityDisabled">
        <span class="">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{{selectedCity}}</span>&nbsp;&nbsp;&nbsp;&nbsp;<span
          class="caret"></span>&nbsp;&nbsp;
      </button>

      <div class="dropdown-menu open" x-placement="bottom-start"
        style="position: absolute; will-change: transform; top: 0px; left: 0px;  width: 90%;">
        <ul class="dropdown-menu inner selectpicker" role="menu" style="width: 100%;">
          <li rel="0" class="" *ngFor="let ciudad of selectedPromo.ciudades; let i = index">
            <div id="{{ciudad}}" tabindex="0" class="btn select-content" (click)="populateBranches2($event)"
              style="outline: unset;">{{ciudad}}
            </div>
          </li>
        </ul>
      </div>
    </div>
    <div class="col-lg-3 text-left">
      <button type="button" class="btn selectpicker btn-primary" data-toggle="dropdown" title="Elige una sucursal"
        aria-expanded="false" style="width: 100%;" [disabled]="selectCityDisabled">
        <span class="">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{{selectedBranchName}}</span>&nbsp;&nbsp;&nbsp;&nbsp;<span
          class="caret"></span>&nbsp;&nbsp;
      </button>

      <div class="dropdown-menu open" x-placement="bottom-start"
        style="position: absolute; will-change: transform; top: 0px; left: 0px;  width: 90%;">
        <ul class="dropdown-menu inner selectpicker" role="menu" style="width: 100%;  overflow:scroll; height:400px;">
          <li rel="0" class="" *ngFor="let sucursal of sucursales; let i = index">
            <div id="{{sucursal.idSucursal}}" tabindex="0" class="btn select-content" (click)="selectBranch2($event)"
              style="outline: unset;">{{sucursal.nombre}}
            </div>
          </li>
        </ul>
      </div>
    </div>
    <div class="col-lg-3 text-right"></div>
  </div>

  <!-- END-- Sucursal for Long-Devices -->

  <!-- Seleccion de Ciudad / Sucursal for Medium-Devices -->
  <div class="row d-none d-md-block d-lg-none p-10 justify-content-center" *ngIf="showMap">
    <div class="col-md-12 text-center">
      <div class="row p-0">

        <div class="col-6 text-right">
          <button type="button" class="btn selectpicker btn-primary" data-toggle="dropdown" title="Elige una ciudad"
            aria-expanded="false" [disabled]="selectCityDisabled">
            <span class="">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{{selectedCity}}</span>&nbsp;&nbsp;&nbsp;&nbsp;<span
              class="caret"></span>&nbsp;&nbsp;
          </button>

          <div class="dropdown-menu open" x-placement="bottom-start"
            style="position: absolute; will-change: transform; top: 0px; left: 0px; width: 100%;">
            <ul class="dropdown-menu inner selectpicker" role="menu">
              <li rel="0" class="" *ngFor="let ciudad of selectedPromo.ciudades; let i = index">
                <div id="{{ciudad}}" tabindex="0" class="btn select-content" (click)="populateBranches2($event)"
                  style="outline: unset;">{{ciudad}}
                </div>
              </li>
            </ul>
          </div>
        </div>


        <div class="col-6 text-left">
          <button type="button" class="btn selectpicker btn-primary" data-toggle="dropdown" title="Elige una sucursal"
            aria-expanded="false" [disabled]="selectCityDisabled">
            <span class="">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{{selectedBranchName}}</span>&nbsp;&nbsp;&nbsp;&nbsp;<span
              class="caret"></span>&nbsp;&nbsp;
          </button>

          <div class="dropdown-menu open" x-placement="bottom-end"
            style="position: absolute; will-change: transform; top: 0px; left: 0px; ">
            <ul class="dropdown-menu inner selectpicker" role="menu"
              style="width: 100%;  overflow:scroll; height:400px;">
              <li rel="0" class="" *ngFor="let sucursal of sucursales; let i = index">
                <div id="{{sucursal.idSucursal}}" tabindex="0" class="btn select-content"
                  (click)="selectBranch2($event)" style="outline: unset;">{{sucursal.nombre}}
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>

    </div>
  </div>
  <!-- END-- Sucursal for Medium-Devices -->

  <!-- Seleccion de Ciudad / Sucursal == Small-Devices -->
  <div class="row d-none d-sm-block d-md-none  p-0 justify-content-center" *ngIf="showMap">

    <div class="row">


      <div class="col-6 text-right">
        <button type="button" class="btn selectpicker btn-primary" data-toggle="dropdown" title="Elige una ciudad"
          aria-expanded="false" [disabled]="selectCityDisabled">
          <span class="">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{{selectedCity}}</span>&nbsp;&nbsp;&nbsp;&nbsp;<span
            class="caret"></span>&nbsp;&nbsp;
        </button>

        <div class="dropdown-menu open" x-placement="bottom-start"
          style="position: absolute; will-change: transform; top: 0px; left: 0px; ">
          <ul class="dropdown-menu inner selectpicker" role="menu">
            <li rel="0" class="" *ngFor="let ciudad of selectedPromo.ciudades; let i = index">
              <div id="{{ciudad}}" tabindex="0" class="btn select-content" (click)="populateBranches2($event)"
                style="outline: unset;">{{ciudad}}
              </div>
            </li>
          </ul>
        </div>
      </div>


      <div class="col-6 text-left">
        <button type="button" class="btn selectpicker btn-primary" data-toggle="dropdown" title="Elige una sucursal"
          aria-expanded="false" [disabled]="selectCityDisabled">
          <span class="">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{{selectedBranchName}}</span>&nbsp;&nbsp;&nbsp;&nbsp;<span
            class="caret"></span>&nbsp;&nbsp;
        </button>

        <div class="dropdown-menu open" x-placement="bottom-end"
          style="position: absolute; will-change: transform; top: 0px; left: 0px; ">
          <ul class="dropdown-menu inner selectpicker" role="menu" style="width: 100%;  overflow:scroll; height:400px;">
            <li rel="0" class="" *ngFor="let sucursal of sucursales; let i = index">
              <div id="{{sucursal.idSucursal}}" tabindex="0" class="btn select-content" (click)="selectBranch2($event)"
                style="outline: unset;">{{sucursal.nombre}}
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
  <!-- END-- Sucursal for == Small-Devices -->


  <!-- Seleccion de Ciudad / Sucursal == XSmall-Devices -->
  <div class="row d-block d-sm-none  p-0 justify-content-center" *ngIf="showMap">

    <div class="row">


      <div class="col-6 text-right p-1">
        <button type="button" class="btn selectpicker btn-primary" data-toggle="dropdown" title="Elige una ciudad"
          aria-expanded="false" [disabled]="selectCityDisabled">
          <span class="">&nbsp;&nbsp;{{selectedCity}}</span>&nbsp;<span
            class="caret"></span>&nbsp;
        </button>

        <div class="dropdown-menu open" x-placement="bottom-start"
          style="position: absolute; will-change: transform; top: 0px; left: 0px; ">
          <ul class="dropdown-menu inner selectpicker" role="menu">
            <li rel="0" class="" *ngFor="let ciudad of selectedPromo.ciudades; let i = index">
              <div id="{{ciudad}}" tabindex="0" class="btn select-content" (click)="populateBranches2($event)"
                style="outline: unset;">{{ciudad}}
              </div>
            </li>
          </ul>
        </div>
      </div>


      <div class="col-6 text-left p-1">
        <button type="button" class="btn selectpicker btn-primary" data-toggle="dropdown" title="Elige una sucursal"
          aria-expanded="false" [disabled]="selectCityDisabled">
          <span class="">&nbsp;&nbsp;{{selectedBranchName}}</span>&nbsp;<span
            class="caret"></span>&nbsp;
        </button>

        <div class="dropdown-menu open" x-placement="bottom-end"
          style="position: absolute; will-change: transform; top: 0px; left: 0px; ">
          <ul class="dropdown-menu inner selectpicker" role="menu" style="width: 100%;  overflow:scroll; height:400px;">
            <li rel="0" class="" *ngFor="let sucursal of sucursales; let i = index">
              <div id="{{sucursal.idSucursal}}" tabindex="0" class="btn select-content" (click)="selectBranch2($event)"
                style="outline: unset;">{{sucursal.nombre}}
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
  <!-- END-- Sucursal for <= Small-Devices -->

  <div class="row p-10">
    <div class="col-lg-12">
      &nbsp;
    </div>
  </div>

</div>

<!-- <div class="container" style="position: relative;">
  <div class="row">
    <div class="col-lg-12">
       <img src="assets/images/map_google.png" width="100%">
       <div #mapContainer id="map"></div>
    </div>
</div> -->

<nav *ngIf="showActivePromo">
  <div *ngIf="showMap" #mapContainer id="map"></div>
<!--  <img *ngIf="!showMap" src="assets/img/mapa_gris.png" width="100%">-->
</nav>

<div class="row p-10">
  <div class="col-lg-12">
  </div>
</div>

<div class="container p-20" style="margin-top: 20px; margin-bottom: 20px;" *ngIf="showActivePromo">
  <div class="row w-100 p-10 dflex justify-content-center">
    <div class="col-lg-12 text-center">

      <button type="button" class="btn btn-primary" [routerLink]="['/cardPromos',selectedIdCard,lastPage]">
        &nbsp;<span class="glyphicon glyphicon-triangle-left" style="color: yellow;"></span> Regresar&nbsp;&nbsp;&nbsp;
      </button>

    </div>
  </div>
</div>


<div class="row p-20" *ngIf="showActivePromo && promosRelated!=undefined && promosRelated.length>0">
  <div class="col-12 text-center">
    <p class="related-promos-legend">Usuarios que vieron esta promoción también se interesaron en estas promociones</p>
  </div>
</div>

<!-- PROMOCIONES RELACIONADAS -->

<div class="DivDataMain bg-light row" *ngIf="showActivePromo && promosRelated!=undefined && promosRelated.length>0">

  <div class="col-md-2 d-flex justify-content-end align-items-center">
    <a id="slideLeft" class="btn d-none d-md-block"  (click)="scrollLeft()"><img src="assets/img/Navegador_Izq.png" width="15px" height="49px" /></a>
  </div>

  <div id="container"  class="col-md-8 col-sm-12 nopadding justify-content-center bg-light pt-3" >

    <div #widgetsContent class="row scrolling-wrapper-flexbox">
      <div class="promobox-mobile" *ngFor="let promo of promosRelated; let i = index">
        <div class="promotion-box" (click)="showPromoDetail(promo.idPromocion)"
             style="outline: transparent;" *ngIf="promo.idTipoPromocion===1">
          <img class="card-img-top" src="{{promo.urlImagen}}" alt="{{promo.nombre}}" width="221" height="168">
          <div class="card-body">
            <img class="card-img-center" src="{{promo.comercio.urlLogoImagen}}" alt="{{promo.comercio.nombre}}"
                 width="75" height="75">
            <h5 class="card-title commerce-name-long" *ngIf="promo.comercio.nombre.length>25">
              {{promo.comercio.nombre}}</h5>
            <h5 class="card-title commerce-name" *ngIf="promo.comercio.nombre.length<=25">
              {{promo.comercio.nombre}}</h5>
            <p class="card-text promo-name">{{promo.nombre}}</p>
          </div>
          <div class="card-footer text-right">
            <!-- <button type="button" class="btn-bc-tertiary btn btn-xs btn-default" (click)="showPromo($event)" id="{{promo.idPromocion}}"> -->
            <button type="button" class="btn-bc-tertiary btn btn-xs btn-default"
                   (click)="showPromoDetail(promo.idPromocion)">
              <!--<div>
                <span class="promo-more">Conoce m&aacute;s</span><span> </span><span><i
                class="icon icon-chevron-right-small" aria-hidden="true"></i></span>
              </div>-->
            </button>
          </div>
        </div>
        <div class="promotion-box" style="outline: transparent;" *ngIf="promo.idTipoPromocion===3"
             (click)="goToLink(promo.urlTargetInformativa, promo.targetInformativa, promo.nombre)">
          <img class="card-img-top" src="{{promo.urlImagen}}" alt="{{promo.nombre}}" width="221" height="319">

          <div class="card-footer text-right">
            <!-- <button type="button" class="btn-bc-tertiary btn btn-xs btn-default" (click)="showPromo($event)" id="{{promo.idPromocion}}"> -->
            <button type="button" class="btn-bc-tertiary btn btn-xs btn-default"
                    (click)="showPromoDetail(promo.idPromocion)">
            </button>
          </div>

        </div>

        <div class="card-footer-margin">
          &nbsp;
        </div>
      </div>
    </div>

  </div>

  <div class="col-md-2 d-flex justify-content-start align-items-center">
    <a id="slideRight" class="btn d-none d-md-block" (click)="scrollRight()" ><img src="assets/img/Navegador_Der.png" width="15px" height="49px" /></a>
  </div>

</div>

